import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static values = {
    userId: String,
    userEmail: String,
    userFullName: String,
    userType: String,
    marinaId: String,
    marinaName: String,
  };

  connect() {
    this.initializePostHog();
  }

  async initializePostHog() {
    try {
      const { default: posthog } = await import("posthog-js");

      // Initialize PostHog only once per page load for trackable users
      if (!window.posthogInitialized) {
        try {
          posthog.init("phc_fwUxwhJoPbdpVjbAJayxbsCrcw0h3BlspUWDezdRlHZ", {
            api_host: "https://compass.metarina.com",
            ui_host: "https://eu.posthog.com",
            defaults: "2025-05-24",
          });
          window.posthogInitialized = true;
        } catch (error) {
          console.error("PostHog initialization failed:", error);
          return;
        }
      }

      // Identify the user with PostHog
      if (this.hasUserIdValue) {
        try {
          const userProperties = {
            email: this.userEmailValue,
            full_name: this.userFullNameValue,
            user_type: this.userTypeValue,
          };

          // Add marina context if available
          if (this.hasMarinaIdValue) {
            userProperties.marina_id = this.marinaIdValue;
            userProperties.marina_name = this.marinaNameValue;
          }

          posthog.identify(this.userIdValue, userProperties);

          // Set group context for marina (useful for B2B analytics)
          if (this.hasMarinaIdValue) {
            posthog.group("marina", this.marinaIdValue, {
              name: this.marinaNameValue,
            });
          }
        } catch (error) {
          console.error("PostHog identify failed:", error);
        }
      }
    } catch (error) {
      console.error("Failed to load PostHog:", error);
    }
  }
}
